import script from "./AdminRoles.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRoles.vue?vue&type=script&setup=true&lang=js"

import "./AdminRoles.vue?vue&type=style&index=0&id=4fca0472&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fca0472"]])

export default __exports__